// extracted by mini-css-extract-plugin
export var cartIcon = "_ms-0";
export var cartIconContainer = "_ms-1";